import { getCustomReport } from 'api/dash'
import { Button } from 'components/parts/button'
import { ReactComponent as DashboardIcon } from 'images/icons/dashboard.svg'
import React, { useEffect, useState } from 'react'
import { Container, EmptyDash, Header, Menu, MenuItem } from './style'

const CustomDash = props => {
	const [customReportDash, setCustomReportDash] = useState(false)
	const [dashboardItem, setDashboardItem] = useState(null)
	const [anchorEl, setAnchorEl] = useState(null)

	useEffect(() => {
		getCustomReport({ screen_location: 'analytic' })
			.then(data => {
				setCustomReportDash(data.data)
			})
			.catch(e => {
				console.log(e)
			})
	}, [])

	const handleClick = event => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	const handleViewDashboard = id => {
		const selectedDashboard = customReportDash.find(item => item.id === id)
		setDashboardItem(selectedDashboard)
	}

	return (
		<Container>
			<Header>
				<h3>Relatórios personalizados</h3>

				<>
					<Button
						aria-controls="simple-menu"
						aria-haspopup="true"
						onClick={handleClick}
						classes={{ root: 'dashboard' }}
					>
						<DashboardIcon />
						Dashboard
					</Button>
					<Menu
						id="simple-menu"
						anchorEl={anchorEl}
						keepMounted
						open={Boolean(anchorEl)}
						onClose={handleClose}
					>
						{customReportDash &&
							customReportDash.map(item => (
								<MenuItem
									onClick={() => handleViewDashboard(item.id)}
									key={item.id}
								>
									{item.description}
								</MenuItem>
							))}
					</Menu>
				</>
			</Header>
			{dashboardItem ? (
				<iframe
					src={dashboardItem.link}
					frameBorder="0"
					style={{ width: '100%', height: '100%' }}
				></iframe>
			) : (
				<EmptyDash>Selecione um dashboard</EmptyDash>
			)}
		</Container>
	)
}

export default CustomDash
